import React from 'react';
import { IconProps } from '.';

const SvgColoredRocket = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#FBD05E' d='m6.805 13.872 3.323 3.323S5.745 19.9 4.91 19.056c-.833-.844 1.894-5.184 1.894-5.184Z' />
      <path
        fill='#F9B75F'
        d='m7.509 14.576 1.915 1.915s-2.532 1.559-3.02 1.072c-.486-.487 1.094-2.998 1.094-2.998l.01.01Z'
      />
      <path
        fill='#E15244'
        d='M8.515 9.175 2 11.46l5.346 3.095 1.17-5.379ZM14.814 15.485 12.54 22l-3.095-5.357 5.368-1.158Z'
      />
      <path
        fill='#E2E5E6'
        d='M16.318 2.162c-1.97.433-4.253 1.786-6.796 4.708-2.912 3.333-3.485 5.974-2.825 7.36.465.984 2.11 2.554 3.074 3.073 1.352.725 4.025.087 7.359-2.825 2.922-2.543 4.275-4.826 4.708-6.796l-5.52-5.52Z'
      />
      <path
        fill='#5A6175'
        d='M21.123 3.006s-.097-.108-.13-.13c-1.277-.714-2.846-1.114-4.675-.714l5.52 5.52c.4-1.83 0-3.399-.715-4.665v-.01ZM15.485 11.318a2.814 2.814 0 1 0 0-5.628 2.814 2.814 0 0 0 0 5.628Z'
      />
      <path fill='#fff' d='M15.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z' />
    </svg>
  );
};

export default SvgColoredRocket;
